import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ReferralWiringInformationStore } from '@roc/feature-referrals';
import { observer } from 'mobx-react';
import { Grid, Divider, Typography } from '@material-ui/core';
import { Button, createNumberFormatField, createNumberFormatFieldWithAdornment, createTextField } from '@roc/ui';
import React, { useEffect } from 'react';
import { ReferralBorrowerAddressInformation } from './referralBorrowerAddressInformation';

const useStyles = makeStyles(theme =>
  createStyles({
    radio: {
      '& label': {
        height: '3.5vh',
      },
    },
  })
);

export type ReferralWiringInformationFormProps = {
  store: ReferralWiringInformationStore;
};
export const ReferralWiringInformationForm = observer(
  (props: ReferralWiringInformationFormProps) => {
    const { store } = props;
    const classes = useStyles();

    const accountNumberOnKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void = (e) => {
      if (
        !/[0-9]/.test(e.key) &&
        !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(e.key) &&
        !(e.ctrlKey || e.metaKey) // allows Ctrl+V, Ctrl+C, Cmd+V, Cmd+C, etc.
      ) {
        e.preventDefault();
      }
    }

    return (
      <Grid item container xs={12} spacing={4}>
        <Grid item container justifyContent="center" spacing={2}>
          <Grid item xs={6}>
            {createTextField({
              store,
              label: 'Bank Name',
              fieldName: 'bankName',
              testId: 'bankName',
            })}
          </Grid>
          <Grid item xs={6}>
            {createTextField({
              store,
              label: 'Bank Account Name',
              fieldName: 'accountName',
              testId: 'accountName',
              placeholder: 'Enter the name as it appears on the account checks',
            })}
          </Grid>
          <Grid item xs={12}>
            {createNumberFormatField({
              store,
              label: 'ACH Routing Number',
              fieldName: 'routingNumber',
              testId: 'routingNumber',
              placeholder: '123456789',
              format: "#########",
              mask: ''
            })}
          </Grid>

          <Grid item xs={6}>
            {createTextField({
              store,
              label: 'Bank Account Number',
              fieldName: 'accountNumber',
              testId: 'accountNumber',
              inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
              onKeyDown: accountNumberOnKeyDown
            })}
          </Grid>
          <Grid item xs={6}>
            {createTextField({
              store,
              label: 'Confirm Bank Account Number',
              fieldName: 'accountNumberConfirmation',
              testId: 'accountNumberConfirmation',
              inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
              onKeyDown: accountNumberOnKeyDown
            })}
          </Grid>
          <Grid item xs={12}>
            <ReferralBorrowerAddressInformation store={store} />
          </Grid>
          <Grid container item xs={12} justifyContent={'space-between'}>
            <Button
              variant="contained"
              testId={'cancel'}
              onClick={() => {
                store.wiringInformationOpen = false;
                store.edit = false;
                store.reset();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              testId={'next'}
              onClick={() => store.moveToSignatureStep()}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
);
